module.exports = __webpack_public_path__ + "img/app_store_button.ee26e968.png";